import React from "react";
import { Link } from "react-router-dom";
import "./Products.css";

import productImg from "../images/car.webp";
import productImg2 from "../images/motor.jpeg";
import productImg3 from "../images/service-fluid/service_category.png"
import productImg4 from "../images/gear.png"

const products = [
  {
    id: 1,
    title: "Engine Oils for Cars & Transporters",
    image: productImg,
    path: "/products/engine-oils-for-cars-and-transporters",
  },
  {
    id: 2,
    title: "Engine oils for Motorbikes & Outboards",
    image: productImg2,
    path: "/products/engine-oils-for-motobikes-and-outboards",
  },
  {
    id:3,
    title:"Operating & service fluids",
    image:productImg3,
    path:"/products/operating-service-fluids"
  }
  ,
   {
    id: 4,
    title: "Gear oils & transmission fluids",
    image: productImg4,
    path: "/products/gear-oils-transmission-fluids",
  },

];

const Products = () => {
  return (
    <>
    <div className="products-page">
      {/* Breadcrumb */}
      <nav className="app-breadcrumb">
        <Link to="/">Home</Link>
        <span className="separator">›</span>
        <span className="current">Products</span>
      </nav>

      {/* Products Grid */}
      <div className="products-grid">
        {products.map((product, index) => (
          <Link
            key={product.id}
            to={product.path}
            className="product-card"
            style={{ animationDelay: `${index * 0.12}s` }}
          >
            <img src={product.image} alt={product.title} />

            {/* Overlay */}
            <div className="card-overlay" />

            {/* Content */}
            <div className="card-content">
              <h2>{product.title}</h2>
              <div className="card-cta">
                <span>Explore</span>
                <span className="cta-arrow">→</span>
              </div>
            </div>
          </Link>
        ))}
      </div>
    </div>
    <a
        href="https://wa.me/7204731100?text=Hello%20I%20need%20details"
        target="_blank"
        rel="noopener noreferrer"
        className="whatsapp-float"
      >
        <img
          src="https://cdn-icons-png.flaticon.com/512/733/733585.png"
          alt="WhatsApp"
        />
      </a>
    </>
    
  );
};

export default Products;
